import React, { ReactElement, ReactNode } from 'react';
import { CardPadding } from './CardPadding';

interface GrayCardProps {
  children: ReactNode;
}

export function GrayCard({ children }: GrayCardProps): ReactElement {
  return (
    <div className="bg-gray-20 text-center rounded-md">
      <CardPadding>{children}</CardPadding>
    </div>
  );
}
